import React from "react";
import { useLDClient } from "launchdarkly-react-client-sdk";

export interface WithBooleanFeatureFlagProps {
  flagKey: string;
  isPageEditing: boolean | undefined;
}

export const withBooleanFeatureFlag = <T extends WithBooleanFeatureFlagProps>(
  WrappedComponent: React.ComponentType<T>
) => {
  return (props: Omit<T, "flagKey" | "enabledByDefault">) => {
    const { flagKey, isPageEditing } = props as T;

    const client = useLDClient();

    const featureEnabled = client ? client.variation(flagKey, true) : true;

    if (featureEnabled) {
      return <WrappedComponent {...(props as T)} />;
    } else if (isPageEditing && !featureEnabled) {
      return (
        <div
          data-testid="featureDisabledWarning"
          className="sc-jss-editing-error"
        >
          This component is currently disabled by a feature flag.
        </div>
      );
    } else {
      return <></>;
    }
  };
};
